import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomToastService } from 'src/app/core/services/custom-toast.service';
import { LoginModel } from '../../models/shared.models';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-account-setup',
  templateUrl: './account-setup.component.html',
  styleUrl: './account-setup.component.css',
  standalone: false,
})
export class AccountSetupComponent {
  togglecpass: boolean = false;
  showNewPass: boolean = false;
  passWord: string = '';
  conFirmPassWord: string = '';
  isAbleToSet: boolean = false;
  errorMsgType: string = '';
  token: string | null = '';
  showPassword: boolean = false;
  loginInfo: LoginModel = new LoginModel();
  companyId: number = 0;

  constructor(
    private sharedService: SharedService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toast: CustomToastService,
  ) {}

  ngOnInit(): void {
    this.resetPasswordValues();
    this.getToken();
  }
  toggleNewPass() {
    this.showNewPass = !this.showNewPass;
  }

  toggleCPasswordVisibility() {
    this.togglecpass = !this.togglecpass;
  }

  getBtnStatus() {
    this.isAbleToSet =
      this.loginInfo.userName && this.passWord && this.conFirmPassWord ? true : false;
    this.errorMsgType = '';
  }

  managePassword() {
    if (this.passWord != this.conFirmPassWord) {
      this.errorMsgType = 'notSame';
    } else if (this.passWord.length < 8) {
      this.errorMsgType = 'passLimit';
    } else {
      this.errorMsgType = '';
      this.setPassword();
    }
  }

  getToken() {
    this.token = this.activatedRoute.snapshot.queryParamMap.get('token');
  }

  resetPasswordValues() {
    this.errorMsgType = '';
    this.loginInfo.userName = '';
    this.passWord = '';
    this.conFirmPassWord = '';
    this.isAbleToSet = false;
  }

  // Method for set password functionality after newly created user
  setPassword() {
    if (this.token) {
      this.loginInfo.password = this.passWord;
      this.loginInfo.token = this.token;
      this.sharedService.setPassword(this.loginInfo).subscribe(
        (res) => {
          this.toast.success('New credentials have been set up successfully!');
          this.router.navigate(['/shared/login']);
        },
        (err) => {
          const canClose = this.sharedService.getErrorMessage(err);
          this.loginInfo = new LoginModel();
          this.passWord = '';
          this.conFirmPassWord = '';
        },
      );
    } else {
      this.toast.error('Provided token is not valid for the current user.');
    }
  }
}
